import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { Order } from '@classes/order/order';
import { OrdersService } from '@services/orders.service';


@Injectable()
export class OrderResolver  {
    constructor(
        private ordersSrv: OrdersService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Order> {
        const id = route.paramMap.get('id');
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.ordersSrv.get(id)
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
